import React, { useState, useEffect, useRef } from 'react';
import { mockServices } from '../mock';

const ServiceCard = ({ service, index }) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const currentRef = cardRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div 
      ref={cardRef}
      className={`service-card ${isVisible ? 'visible' : ''}`}
      style={{ transitionDelay: `${index * 0.2}s` }}
    >
      <div className="service-image-wrapper">
        <img 
          src={service.image} 
          alt={service.title} 
          className="service-image"
        />
      </div>
      <div className="service-content">
        <h3 className="service-title">{service.title}</h3>
        <p className="service-description">{service.description}</p>
      </div>
    </div>
  );
};

const Services = () => {
  return (
    <section className="services-section">
      <div className="container">
        <div className="services-header">
          <p className="services-label">( Our Services )</p>
          <h2 className="services-title">What We Do</h2>
        </div>
        <div className="services-grid">
          {mockServices.map((service, index) => (
            <ServiceCard key={service.id} service={service} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
